<template>
	<div class="absolute flex justify-center items-center w-fit overflow-visible" ref="mainEl">
		<img alt="" src="images/1x_images/keytech-dot.png" srcset="images/2x_images/keytech-dot.png 2x" class="z-[2]" />
		<img alt="" src="images/1x_images/keytech-dot-bg.png" srcset="images/2x_images/keytech-dot-bg.png 2x" class="absolute z-[1] origin-center will-change-transform" ref="pulsateEl" />
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	name: "dot-1",
	props: {
		pWidth: 0,
	},
	data() {
		return {
			tween: null,
		};
	},
	methods: {
		start() {
			this.tween = gsap.fromTo(this.$refs.pulsateEl, { scale: 1, autoAlpha: 0.5 }, { scale: 5, autoAlpha: 0, duration: 0.8, ease: "out", overwrite: true, repeat: -1, repeatDelay: 0.8 });
		},
		stop() {
			if (this.tween) this.tween.kill();
			gsap.set(this.$refs.pulsateEl, { autoAlpha: 0.5, scale: 1, overwrite: true });
		},
		fadeIn() {
			gsap.to(this.$refs.mainEl, { autoAlpha: 1, duration: 0.5, ease: "none", overwrite: true });
		},
		fadeOut() {
			// prettier-ignore
			gsap.to(this.$refs.mainEl, { autoAlpha: 0, duration: 0.7, ease: "none", overwrite: true, onComplete:()=>{
				this.stop();
			}});
		},
	},
	mounted() {
		gsap.set(this.$refs.pulsateEl, { autoAlpha: 0.5 });
	},
};
</script>

<style scoped></style>
